<template>
    <div>
        <top_box :return_="true" :user_data="user_data"></top_box>
        <div class="kongbox"></div>
        <div class="main" :style="{ 'height': screenHeight + 'px' }">
        <img src="../../static/images/tijiaoOK.png" alt="">
            <h2>{{$t('m.Submit_01')}}</h2>
            <p>{{$t('m.Submit_02')}}</p>
            <div class="foot_btnbox">
                <div class="btnbox pointer" @click="MallCenter">
                    <span>{{$t('m.Submit_03')}}</span>
                </div>
                <div class="btnbox1 pointer" @click="order_info">
                    <span>{{$t('m.Submit_04')}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import top_box from '../../components/header_top'
export default {
    components: {
        top_box,

    },
    data() {
        return {
            user_data: {},
            screenHeight:'',
            order_id:''
        }
    },
    mounted() {
        this.order_id = this.$route.query.order_id
        let user_data = JSON.parse(localStorage.getItem('user_data'))
        this.user_data = user_data
        window.screenHeight = document.documentElement.clientHeight; //实时高度
        this.screenHeight = window.screenHeight - 80 - 25;

    },
    methods: {
        MallCenter(){
            this.$router.push({
                path: '/user/MallCenter'
            })
        },
        order_info(){
            this.$router.push({
                path: '/user/order_info?order_id='+this.order_id
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.kongbox{
    height: 15px;
}
.main {
    
   
    border-top: 5px solid #ef5843;
    background-image: linear-gradient(180deg, #fde9e6 0%, #ffffff 60%);
    background-image: url(../../static/images/brand/login_bac.png);
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    h2{
        margin-top: 30px;
    }
    p{
        margin-top: 20px;
    }
    .foot_btnbox {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;

        .btnbox {
            background-color: #ef5843;
            height: 60px;
            width: 210px;
            display: flex;
            align-items: center;
            color: #fff;
            border-radius: 4px;
            justify-content: center;
            font-weight: bold;


            span {
                margin-left: 6px;
            }
        }

        .btnbox1 {
            background-color: #fff;
            color: #ef5843;
            border: 3px solid #ef5843;
            border-radius: 4px;
           height: 60px;
            width: 210px;
            margin-left: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;


        }
    }
}



// 宽度小于1200px
@media screen and (max-width: 1200px){
	.main{
		>p{
			padding: 0 0.5rem;
			text-align: center;
		}
		.foot_btnbox{
			width: 100%;
			padding: 0 0.5rem;
			div{
				width: 50%!important;
				font-size: 0.85rem;
			}
		}
	}
}
</style>